import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { UsuariosProvider } from '../../providers/usuarios/usuarios';
import { UtilsProvider } from '../../providers/utils/utils';
@Component({
  selector: 'teclado',
  templateUrl: 'teclado.html',
  providers: []
})
export class TecladoComponent  {

  clave: string = '';
  numeros: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
  usuario;
  mostrarPopup: boolean = false; // Controlar la visibilidad del popup
  claveActualizar: string = '';
  constructor(public viewCtrl: ViewController, public navParams: NavParams,
    public servicio: UsuariosProvider,public utils:UtilsProvider
  ) {
    this.usuario = this.navParams.get('usuario');
  }

  agregarNumero(num: number) {
    if (this.clave.length < 4) {
      this.clave += num.toString();
    }
  }

  borrarClave() {
    this.clave = '';
  }

  ingresarClave() {
    this.viewCtrl.dismiss(this.clave,this.usuario.usuariosId); // Envia la clave de vuelta
  }

  cerrarModal() {
    this.viewCtrl.dismiss(null); // Cierra sin enviar clave
  }

 // Función para abrir el popup
 abrirConfiguracion() {
  this.mostrarPopup = true;
}

// Función para cerrar el popup
cerrarPopup() {
  this.mostrarPopup = false;
  this.claveActualizar = ''; // Limpiar el campo de clave
}

// Función para actualizar la clave
async actualizarClave() {
  if (this.claveActualizar.length === 4) {
    let usuariosId = await localStorage.getItem('usuariosId');
    let administrador = await localStorage.getItem('administrador');
    const esAdmin = administrador === "true"; // Convierte administrador a booleano real
    const idUsuarioActual = Number(usuariosId); // Convierte usuariosId a número

    if (esAdmin || idUsuarioActual === this.usuario.usuariosId) {
      let data =  await this.servicio.actulizarClavePedidosSalonPorUsuarioId(this.usuario.usuariosId, this.claveActualizar)
      let response:any = JSON.parse(data['_body']).data[0]
     if(response !== null && response[0]) {
      this.utils.mensajeMuestro('Clave pedido salón','La clave se actualizo con exito','success')
      this.cerrarPopup(); // Cerrar el popup después de actualizar la clave
      } else {
        this.utils.mensajeMuestro('Clave pedido salón','La clave no se actualizo verifique','warning')
      }
    } else {
      this.utils.mensajeMuestro('Clave pedido salón','No tiene permisos para actualizar la clave de este usuario verifique','warning')
    }

  }
}
}





// WEBPACK FOOTER //
// ./src/components/teclado/teclado.ts